import React from "react";
import { connect } from "react-redux";
import { logout } from "../../modules/actions/authActions";
class DashboardBanner extends React.Component {
  logout(e) {
    e.preventDefault();
    this.props.logout();
  }
  render() {
    const { isAuthenticated, user } = this.props;
    return (
      <section className="dashboard-section">
        {/* <div className="bg-overlay" /> */}
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              &nbsp;&nbsp;

              {/* <div className="text-white text-center">
                <h2 className="font-weight-bold fonts-italic capitalize-h2">
                  Welcome, {isAuthenticated ? user.user.profile.name : null}{" "}
                </h2>
                <div className="home_divider mt-3 mb-3 mx-auto" /></div>
              </div> */}

              </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  { logout }
)(DashboardBanner);



// WEBPACK FOOTER //
// ./src/pages/dashboard/DashboardBanner.js